import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ICarouselImage } from 'src/app/interfaces/carousel-image';
import { IListingDataSourceConfig } from 'src/app/interfaces/listing-data-source-config';

import { ApiService } from '../../../app/services/api.service';
import { CarouselImagesList } from '../components/list/component';
import { CarouselImageDataSource } from './carousel-image-data-source';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { environment } from 'src/environments/environment';

@Injectable()
export abstract class CarouselImageApiService {
  constructor(
    private Api: ApiService,
    private dialog: MatDialog,
    private commonFunctionService: CommonFunctionService
  ) {}

  public getDataSource(DataSourceConfig: IListingDataSourceConfig) {
    return new CarouselImageDataSource(DataSourceConfig, this);
  }

  public list(productId: number, role: string) {
    return new Promise((resolve, reject) => {
      const endpoint = this.getEndpoint(productId);
      const url = this.commonFunctionService.findApiUrl(role);

      setTimeout(() =>
        this.Api.get(endpoint, url).then(
          (result: ICarouselImage[]) => resolve(result),
          (error) => reject(error)
        )
      );
    });
  }

  public viewList(DataSource: CarouselImageDataSource, role?: string) {
    const config = new MatDialogConfig();
    DataSource.role = role;
    config.data = DataSource;
    config.disableClose = true;
    return this.dialog.open(CarouselImagesList, config);
  }

  public save(productId: number, CarouselImage: ICarouselImage) {
    const endpoint = `listing-admin/carousel/product-id/${productId}/add-images`;
    return this.Api.put(
      endpoint,
      CarouselImage,
      environment.listingAdminUrl
    ).then(
      () => this.Api.handleSuccess('Images added to listing'),
      (error) => this.Api.handleError(error)
    );
  }

  public setFeaturedImage(
    role: string,
    productId: number,
    CarouselImage: ICarouselImage,
    currentFeaturedImage: number
  ) {
    const endpoint = `${role}/carousel/organisation-id/${productId}/update-image`;
    const data = {
      oldImgId: currentFeaturedImage,
      newImgId: CarouselImage.company_image_id,
    };
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.put(endpoint, data, url).then(
      () => this.Api.handleSuccess('Featured image set.'),
      (error) => this.Api.handleError(error)
    );
  }

  public delete(
    role: string,
    productId: number,
    CarouselImage: ICarouselImage
  ) {
    const endpoint = `${role}/carousel/${productId}/image-id/${CarouselImage.prod_img_id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url, { name: CarouselImage.title }).then(
      () => this.Api.handleSuccess(CarouselImage.title + ' deleted.'),
      (error) => this.Api.handleError(error)
    );
  }

  protected abstract getEndpoint(productId: number): string;
}
